import { render, staticRenderFns } from "./seriveDetail.vue?vue&type=template&id=6db6d2fa&scoped=true"
import script from "./seriveDetail.vue?vue&type=script&lang=js"
export * from "./seriveDetail.vue?vue&type=script&lang=js"
import style0 from "./seriveDetail.vue?vue&type=style&index=0&id=6db6d2fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db6d2fa",
  null
  
)

export default component.exports